import { render, staticRenderFns } from "./relatedProductsSummary.vue?vue&type=template&id=b9efc1e4&scoped=true&"
import script from "./relatedProductsSummary.vue?vue&type=script&lang=js&"
export * from "./relatedProductsSummary.vue?vue&type=script&lang=js&"
import style0 from "./relatedProductsSummary.vue?vue&type=style&index=0&id=b9efc1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9efc1e4",
  null
  
)

export default component.exports